function bannerInfo(state = { isBanerUpdateRequired: false }, action) {
  switch (action.type) {
    case 'BANNER_INFO': {
      return { ...state, bannerInfo: action.bannerInfo };
    }
    case 'BANNER_CUSTOMER_INFO': {
      return { ...state, customerInfo: action.customerInfo };
    }
    case 'SET_BANNER_UPDATED_STATUS': {
      return { ...state, isBanerUpdateRequired: action.status };
    }
    case 'SET_RUNTIME_BANNER_PAGE_INFO': {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
}

export default bannerInfo;
